<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧景区</h2>
        <h3>智慧景区分销系统</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview mb100">
        <!-- <div class="fl">
          <img src="../../../assets/img/smart/zhdp_summary_Image.png" alt="" />
        </div> -->
        <div>
          <h2>智慧景区分销系统</h2>
          <p>旅游门票分销系统的主要功能是将各景区及分销商(旅行社、OTA)直接联系起来，打造一个具有较高权威及可信度的第三方票务服务系统，安全便捷高效的实现电子门票生成、发送、验票、款项回收等无缝环节，不但大幅度扩大景区分销渠道，提升门票销量，还帮助景区实现智能化管理，使分销商与景区之间通过网络无缝对接，大大改善工作效率，节省人力。</p>
        </div>
      </div>
    </div>
    <!-- 方案优势 -->
    <div class="container clearfix">
      <div class="smart-title">方案优势</div>
      <ul class="smart-strength clearfix">
        <li>
          <h2>为景区提供健全的分销体系</h2>
          <p>各地的分销商可以便捷的在系统上预订景区门票，极大的扁平化整个门票销售的渠道模式，并利用该模式在价格及快捷方面的优势快速提升分销商数量</p>
        </li>
        <li>
          <h2>提供更多的分销渠道</h2>
          <p>系统将景区门票的分销渠道全线铺开扩充，融汇传统旅行社、OTA、酒店、电商网站、地方网站、中小旅游系统等，并且将分销渠道接口统一，无需景区进行单个分销商的商谈接洽，无限量增加了景区门票的销售渠道，获得更多的销售数量</p>
        </li>
        <li>
          <h2>景区与分销商的自由合作</h2>
          <p>景区可独立自由为分销商制定不同的价格政策和信用政策;景区自由管理自己的分销商及客户信息;景区与分销商自由协定结算方式和途径</p>
        </li>
        <li>
          <h2>简便的一键分销管理</h2>
          <p>景区通过旅游分销系统销售门票，仅需按照系统固定模板填写门票基本信息，信息确认后一键即可发布到分销系统，系统内指定分销商第一时间便可了解掌握景区门票信息</p>
        </li>
        <li>
          <h2>便捷的渠道管理</h2>
          <p>景区可以通过旅游分销系统管理已合作分销商，赋予分销商信用额，管理他的结算周期，增加他的储值余额，配置不同的价格模板，解除合作等;并可通过系统寻找并添加优质分销商建立长期紧密合作</p>
        </li>
        <li>
          <h2>周密的价格体系管理</h2>
          <p>景区自行设定不同区域市场、不同销售渠道、不同客户类型的合作价格，分销系统将根据景区的设置自动发布至相应渠道，景区可以根据自身需要修改合作价格，并可通过系统为重点客户设定特殊政策</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'smartscenicspotdistributionSystem',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/backgroundscenic_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
.smart-strength {
  display: table;
  margin-right: -132px;
}
.smart-strength li {
  float: left;
  width: 366px;
  height: 160px;
  margin-right: 41px;
  margin-bottom: 50px;
}
.smart-strength li h2 {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.smart-strength li p {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
}
</style>
